const SERVER_HOST = process.env.REACT_APP_API_URL;
const GOLFCLIX_SERVER_HOST = process.env.REACT_APP_GOLFCLIX_URL;
const GOLFCLIX_SERVER_API_KEY = process.env.REACT_APP_GOLFCLIX_API_KEY;
const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY;
const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;

export const API_URL = SERVER_HOST;
export const GOLFCLIX_API_URL = GOLFCLIX_SERVER_HOST;
export const GOLFCLIX_API_KEY = GOLFCLIX_SERVER_API_KEY;

export const STRIPE_PUBLISH_KEY = STRIPE_KEY;
export const GOOGLE_MAP_KEY = GOOGLE_MAP_API_KEY;

export const AUTHENTICATE_USER = "api/auth/local";
export const GOLFCLIX_AUTHENTICATE_USER = "user/login";
export const REGISTER_USER = "api/auth/local/register";
export const REGISTER_GOLFCLIX_USER = "user/register";
export const CLUB_LIST = "club/clubs";
export const MAKE_HOME_CLUB = "club/homeclub";
export const USER_DETAIL = "user/users";
export const GOLFCLIX_CHANGE_PASSWORD = "user/changepassword";
export const GOLFCLIX_FORGOT_PASSWORD = "user/forgotpassword";
export const GOLFCLIX_UPDATE_PROFILE = "user/users";
export const GOLFCLIX_COUNTRYS = "common/countries";
export const CHANGE_PASSWORD = "api/auth/change-password";
export const UPDATE_USER = "api/users";
export const GET_USER = "api/users";
export const PROFILE_PHOTO = "api/upload";
export const MENUS = "api/menus?populate=items.parent";
export const HEADERS = "api/header?populate=*";
export const FORGOT_PASSWORD = "api/auth/forgot-password";
export const HOME_PAGE_SETTING = "api/home-pages";
export const PRIVACY_DATA = "api/privacy-policy";
export const SETTING = "api/setting?populate=*";
export const STATIC_PAGE = "api/page/static-page";
export const RESET_PASSWORD = "api/auth/reset-password";
export const FEATURED_CLUBS_NEAR_ME =
  "api/clubs/featured-near/list?populate=image";
export const BANNER = "api/banner?populate=image";
export const PLAY_NINE_CLUBS = "api/clubs/play-nine/list?populate=image";
export const DRIVING_RANGE_CLUBS_NEAR_ME =
  "api/clubs/driving-range/list?populate=image";
export const PUTTING_GREEN_CLUBS_NEAR_ME =
  "api/clubs/green-clubs/list?populate=image";
export const TEACHING_PRO_CLUBS_NEAR_ME =
  "api/clubs/teaching-pro/list?populate=image";
export const PITCHING_AREA_CLUBS_NEAR_ME =
  "api/clubs/pitching-area/list?populate=image";
export const NEWS = "api/news-feeds";
export const NEWSLETTER = "api/news-letters";
export const EXPOLRE_GAME = "api/explore-games?populate=image";
export const COUNTRY_LIST = "api/get-countries";
export const DESTINATION_LIST = "api/destinations?populate=*";
export const DESTINATION_DETAIL = "api/destinations";
export const LATEST_REVIEW = "api/review-and-ratings";
export const REVIEW_RATING = "/api/review-and-ratings";
export const CLUB_DETAIL = "api/clubs";
export const CLUB_POLICY = "api/clubs/club-detail";
export const CLUB_SEARCH = "api/clubs/search-keyword/list";
export const FACILITES = "api/clubs/facility-detail";
export const TODAYS_BEST_DEAL_NEAR_ME = "api/clubs/near-me?populate=*";

export const CLUB_TEE_TIME = "api/tee-times/club";
export const CATCHING_TEETIME = "api/chached/tee-times";

export const BOOK_TEETIME = "api/booking";
export const GET_LISTING_BOOKING = "api/booking/bookings";
export const CREATE_CUSTOMER = "api/payment/create-stripe-customer";
export const CREATE_PAYMENT = "api/payment";
export const PAYMENT_UPDATE_BOOKING = "api/payment/update-booking";

export const QUERY = "api/queries";

export const LIKE = "api/likes/news";
export const LIKE_CLUB = "api/favourite-clubs";
export const PARTNER_FACILITY = "api/clubs/partner-facility";
export const USER_OTP = "api/users-permissions/users/otp-verification";
export const PAYMENT_DETAIL = "api/payment/detail";
export const CANCEL_BOOKING = "api/booking/cancel";

export const CLUB_SORTING_OPTIONS = "api/clubs-sortings";
export const SEARCH_CLUBS = "api/clubs/search/club";

export const COMMENT = "api/comments";

const Config = {
  SERVER_HOST,
};

export default Config;
